import React, { Component } from "react";
import { TextField, Button } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { ShopSubmitBtn, CustomModal, DeleteConfirmationModal } from "../../common";
import { useApiRequests } from "../../services";
import AddNewTypeModal from "./AddNewTypeModal";
import EditTypeModal from "./EditTypeModal";
import AddNewValueModal from "./AddNewValueModal";
import "./styles.scss";

export class RequestKudosTransaction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedEmployee: "",
      kudosAmount: 0,
      reason: "",
      selectedKudosType: null,
      selectedKudosTypeValue: null,
      kudosTypes: [],
      kudosTypesValues: [],
      isEditTypeModalOpen: false,
      isAddNewTypeModalOpen: false,
      expandedTypeId: null,
      typeBeingEdited: null,
      editedTypeName: "",
      newTypeName: "",
      valueBeingEdited: null,
      editedValueName: "",
      editedValue: 0,
      editedIsAvailable: true,
      newValueName: "",
      newValue: 0,
      isAddNewValueModalOpen: false,
      isConfirmationModalOpen: false,
      actionToConfirm: null,
      actionParams: null,
      // New delete flow state for values
      isDeleteValueModalOpen: false,
      deleteValuePreCheck: null,
      valueIdToDelete: null,
      valueNameToDelete: "",
      isDeleteLoading: false,
    };
  }

  async componentDidMount() {
    const { getAllRequestKudosTypes } = useApiRequests();
    try {
      const kudosTypesResponse = await getAllRequestKudosTypes();
      this.setState({
        kudosTypes: kudosTypesResponse.data,
      });
    } catch (error) {
      console.log(error.message);
    }
  }

  handleEmployeeChange = (event, value) => {
    this.setState({
      selectedEmployee: value,
    });
  };

  handleAmountChange = (event) => {
    this.setState({ kudosAmount: event.target.value });
  };

  handleReasonChange = (event) => {
    this.setState({ reason: event.target.value });
  };

  onEmployeeChange = (event, value) => {
    this.setState({
      selectedEmployee: value,
    });
  };

  onKudosTypeChange = async (event, value) => {
    this.setState({
      selectedKudosType: value,
    });

    if (value) {
      const { getRequestKudosTypesValuesByRequestKudosTypeId } = useApiRequests();
      try {
        const response = await getRequestKudosTypesValuesByRequestKudosTypeId(value.id);
        this.setState({
          kudosTypesValues: response.data,
        });
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  onKudosTypeValueChange = (event, value) => {
    this.setState({
      selectedKudosTypeValue: value,
    });
  };

  handleOpenEditTypeModal = () => {
    this.setState({ isEditTypeModalOpen: true });
  };

  handleCloseEditTypeModal = () => {
    this.setState({ isEditTypeModalOpen: false, typeBeingEdited: null, editedTypeName: "", valueBeingEdited: null, editedValueName: "", editedValue: 0, editedIsAvailable: true });
  };

  handleOpenAddNewTypeModal = () => {
    this.setState({ isAddNewTypeModalOpen: true });
  };

  handleCloseAddNewTypeModal = () => {
    this.setState({ isAddNewTypeModalOpen: false, newTypeName: "" });
  };

  handleOpenAddNewValueModal = (type) => {
    this.setState({ selectedKudosType: type, isAddNewValueModalOpen: true });
  };

  handleCloseAddNewValueModal = () => {
    this.setState({ isAddNewValueModalOpen: false, newValueName: "", newValue: 0 });
  };

  handleRequestKudos = () => {
    const { requestKudos } = useApiRequests();
    const { selectedEmployee, selectedKudosType, selectedKudosTypeValue,  reason } = this.state;
    requestKudos( selectedEmployee, selectedKudosType, selectedKudosTypeValue,  reason);
    this.props.clearInputs();
  };

  toggleExpandType = async (typeId) => {
    const { getRequestKudosTypesValuesByRequestKudosTypeId } = useApiRequests();
    this.setState((prevState) => ({
      expandedTypeId: prevState.expandedTypeId === typeId ? null : typeId,
    }));
    if (this.state.expandedTypeId !== typeId) {
      try {
        const response = await getRequestKudosTypesValuesByRequestKudosTypeId(typeId);
        this.setState({
          kudosTypesValues: response.data,
        });
      } catch (error) {
        console.log(error.message);
      }
    }
  };

  editType = (typeId) => {
    const type = this.state.kudosTypes.find((type) => type.id === typeId);
    this.setState({ typeBeingEdited: type, editedTypeName: type.name });
  };

  handleEditTypeNameChange = (event) => {
    this.setState({ editedTypeName: event.target.value });
  };

  handleSaveEditedType = () => {
    this.openConfirmationModal(this.confirmSaveEditedType);
  };

  confirmSaveEditedType = async () => {
    const { typeBeingEdited, editedTypeName, kudosTypes } = this.state;
    const { putRequestKudosType } = useApiRequests();
    try {
      await putRequestKudosType({ id: typeBeingEdited.id, name: editedTypeName });
      const updatedTypes = kudosTypes.map((type) =>
        type.id === typeBeingEdited.id ? { ...type, name: editedTypeName } : type
      );
      this.setState({ kudosTypes: updatedTypes, typeBeingEdited: null, editedTypeName: "" });
    } catch (error) {
      console.log(error.message);
    }
  };

  handleDeleteType = (typeId) => {
    this.openConfirmationModal(this.confirmDeleteType, typeId);
  };

  confirmDeleteType = async (typeId) => {
    const { deleteRequestKudosType } = useApiRequests();
    try {
      await deleteRequestKudosType(typeId);
      this.setState((prevState) => ({
        kudosTypes: prevState.kudosTypes.filter((type) => type.id !== typeId),
      }));
    } catch (error) {
      console.log(error.message);
    }
  };

  handleNewTypeNameChange = (event) => {
    this.setState({ newTypeName: event.target.value });
  };

  handleAddNewType = () => {
    this.openConfirmationModal(this.confirmAddNewType);
  };

  confirmAddNewType = async () => {
    const { newTypeName } = this.state;
    const { postRequestKudosTypes, getAllRequestKudosTypes } = useApiRequests();
  
    try {
      await postRequestKudosTypes(newTypeName);
      const kudosTypesResponse = await getAllRequestKudosTypes();
      this.setState({
        kudosTypes: kudosTypesResponse.data,
        newTypeName: ""
      });
      this.handleCloseAddNewTypeModal();
    } catch (error) {
      console.log(error.message);
    }
  };

  editValueType = (valueId) => {
    const value = this.state.kudosTypesValues.find((value) => value.id === valueId);
    this.setState({ valueBeingEdited: value, editedValueName: value.name, editedValue: value.value, editedIsAvailable: value.isAvailable });
  };

  handleEditValueNameChange = (event) => {
    this.setState({ editedValueName: event.target.value });
  };

  handleEditValueChange = (event) => {
    this.setState({ editedValue: event.target.value });
  };

  handleEditIsAvailableChange = (event) => {
    this.setState({ editedIsAvailable: event.target.value === "active" });
  };

  handleSaveEditedValue = () => {
    this.openConfirmationModal(this.confirmSaveEditedValue);
  };

  confirmSaveEditedValue = async () => {
    const { valueBeingEdited, editedValueName, editedValue, editedIsAvailable, kudosTypesValues } = this.state;
    const { putRequestKudosTypeValue } = useApiRequests();
    try {
      await putRequestKudosTypeValue({ id: valueBeingEdited.id, name: editedValueName, value: editedValue, isAvailable: editedIsAvailable, requestKudosTypeId: valueBeingEdited.requestKudosTypeId });
      const updatedValues = kudosTypesValues.map((value) =>
        value.id === valueBeingEdited.id ? { ...value, name: editedValueName, value: editedValue, isAvailable: editedIsAvailable } : value
      );
      this.setState({ kudosTypesValues: updatedValues, valueBeingEdited: null, editedValueName: "", editedValue: 0, editedIsAvailable: true });
    } catch (error) {
      console.log(error.message);
    }
  };

  // New delete flow: Pre-check before showing modal
  handleDeleteValueType = async (valueId) => {
    const apiRequests = useApiRequests();
    const value = this.state.kudosTypesValues.find(v => v.id === valueId);

    try {
      const response = await apiRequests.preCheckDeleteKudosTypeValue(valueId);
      const preCheckData = response.data;

      this.setState({
        deleteValuePreCheck: preCheckData,
        valueIdToDelete: valueId,
        valueNameToDelete: value ? value.name : preCheckData.itemName,
        isDeleteValueModalOpen: true,
      });
    } catch (error) {
      console.error("Error checking value dependencies:", error);
      // Fallback to simple delete modal if precheck fails
      this.setState({
        deleteValuePreCheck: { hasLinkedRecords: false },
        valueIdToDelete: valueId,
        valueNameToDelete: value ? value.name : "Value",
        isDeleteValueModalOpen: true,
      });
    }
  };

  // Handle archive action for value
  handleArchiveValue = async () => {
    const { valueIdToDelete } = this.state;
    const apiRequests = useApiRequests();

    this.setState({ isDeleteLoading: true });

    try {
      const response = await apiRequests.deleteKudosTypeValueAction(valueIdToDelete, 0); // 0 = Archive

      if (response.status === 200) {
        // Refresh the values list
        const { expandedTypeId } = this.state;
        if (expandedTypeId) {
          const valuesResponse = await apiRequests.getRequestKudosTypesValuesByRequestKudosTypeId(expandedTypeId);
          this.setState({
            kudosTypesValues: valuesResponse.data,
          });
        }
        this.setState({
          isDeleteValueModalOpen: false,
          valueIdToDelete: null,
          deleteValuePreCheck: null,
          valueNameToDelete: "",
          isDeleteLoading: false,
        });
      }
    } catch (error) {
      console.error("Error archiving value:", error);
      this.setState({ isDeleteLoading: false });
    }
  };

  // Handle permanent delete for value
  handlePermanentDeleteValue = async () => {
    const { valueIdToDelete, deleteValuePreCheck } = this.state;
    const apiRequests = useApiRequests();

    this.setState({ isDeleteLoading: true });

    try {
      // If has linked records, use the new action endpoint
      if (deleteValuePreCheck && deleteValuePreCheck.hasLinkedRecords) {
        const response = await apiRequests.deleteKudosTypeValueAction(valueIdToDelete, 1); // 1 = Delete

        if (response.status === 200) {
          this.setState((prevState) => ({
            kudosTypesValues: prevState.kudosTypesValues.filter((value) => value.id !== valueIdToDelete),
            isDeleteValueModalOpen: false,
            valueIdToDelete: null,
            deleteValuePreCheck: null,
            valueNameToDelete: "",
            isDeleteLoading: false,
          }));
        }
      } else {
        // No linked records, use simple delete
        const response = await apiRequests.deleteRequestKudosTypeValue(valueIdToDelete);

        if (response.status === 200) {
          this.setState((prevState) => ({
            kudosTypesValues: prevState.kudosTypesValues.filter((value) => value.id !== valueIdToDelete),
            isDeleteValueModalOpen: false,
            valueIdToDelete: null,
            deleteValuePreCheck: null,
            valueNameToDelete: "",
            isDeleteLoading: false,
          }));
        }
      }
    } catch (error) {
      console.error("Error deleting value:", error);
      this.setState({ isDeleteLoading: false });
    }
  };

  handleCloseDeleteValueModal = () => {
    this.setState({
      isDeleteValueModalOpen: false,
      valueIdToDelete: null,
      deleteValuePreCheck: null,
      valueNameToDelete: "",
    });
  };

  confirmDeleteValueType = async (valueId) => {
    const { deleteRequestKudosTypeValue } = useApiRequests();
    try {
      await deleteRequestKudosTypeValue(valueId);
      this.setState((prevState) => ({
        kudosTypesValues: prevState.kudosTypesValues.filter((value) => value.id !== valueId),
      }));
    } catch (error) {
      console.log(error.message);
    }
  };

  handleNewValueNameChange = (event) => {
    this.setState({ newValueName: event.target.value });
  };

  handleNewValueChange = (event) => {
    this.setState({ newValue: event.target.value });
  };

  handleAddNewValue = (newValueName, newValue) => {
    this.setState({ newValueName, newValue }, () => {
      this.openConfirmationModal(this.confirmAddNewValue);
    });
  };

  confirmAddNewValue = async () => {
    const { newValueName, newValue, selectedKudosType } = this.state;
    const { postRequestKudosTypeValue, getRequestKudosTypesValuesByRequestKudosTypeId } = useApiRequests();
    try {
      await postRequestKudosTypeValue(newValueName, newValue, selectedKudosType.id);
      const response = await getRequestKudosTypesValuesByRequestKudosTypeId(selectedKudosType.id);
      this.setState({ kudosTypesValues: response.data, newValueName: "", newValue: 0 });
      this.handleCloseAddNewValueModal();
    } catch (error) {
      console.log(error.message);
    }
  };

  handleBackFromEditTypeModal = () => {
    if (this.state.typeBeingEdited || this.state.valueBeingEdited) {
      this.setState({ typeBeingEdited: null, editedTypeName: "", valueBeingEdited: null, editedValueName: "", editedValue: 0, editedIsAvailable: true });
    } else {
      this.handleCloseEditTypeModal();
    }
  };

  handleBackFromAddNewTypeModal = () => {
    this.handleCloseAddNewTypeModal();
  };

  openConfirmationModal = (action, params) => {
    this.setState({ isConfirmationModalOpen: true, actionToConfirm: action, actionParams: params });
  };

  handleConfirmAction = async () => {
    const { actionToConfirm, actionParams } = this.state;
    if (actionToConfirm) {
      await actionToConfirm(actionParams);
      this.setState({ isConfirmationModalOpen: false, actionToConfirm: null, actionParams: null });
    }
  };

  handleCloseConfirmationModal = () => {
    this.setState({ isConfirmationModalOpen: false, actionToConfirm: null, actionParams: null });
  };

  handleCancelConfirmationAction = () => {
    this.setState({ 
      isConfirmationModalOpen: false, 
      actionToConfirm: null, 
      actionParams: null 
    });
    // Use parent's handleCancelAction if available
    if (this.props.handleCancelAction) {
      this.props.handleCancelAction();
    }
  };

  render() {
    const { userType } = this.props; 
    const { isConfirmationModalOpen } = this.state;
    return (
      <>
        <div className="form-group d-sm-flex justify-content-start align-items-center">
          <label className="no-padding col-4" htmlFor="kudosType">
            To whom:
          </label>
         <Autocomplete
             id="combo-box-demo"
              getOptionLabel={(option) => `${option.fullName}`}
              style={{ width: 350 }}
              options={this.props.userData}
              onChange={this.onEmployeeChange}
              renderInput={(params) => (
            <TextField {...params} variant="outlined" />
              )}
              renderOption={(option) => (
          <div>
      <h4>{option.fullName}</h4>
    </div>
  )}
/>
        </div>
        <div className="form-group d-sm-flex justify-content-start align-items-center">
          <label className="no-padding col-4" htmlFor="kudosType">
            Please choose Kudos category:
          </label>
          <Autocomplete
            id="kudos-type-dropdown"
            getOptionLabel={(option) => `${option.name}`}
            style={{ width: 350 }}
            options={this.state.kudosTypes}
            onChange={this.onKudosTypeChange}
            renderInput={(params) => <TextField {...params} variant="outlined" />}
            renderOption={(option) => (
              <div>
                <h4>{option.name}</h4>
              </div>
            )}
          />
        </div>
        <div className="form-group d-sm-flex justify-content-start align-items-center">
          <label className="no-padding col-4" htmlFor="kudosTypeValues">
            Please choose the relevant sub-category:
          </label>
          <Autocomplete
            id="kudos-type-value-dropdown"
            getOptionLabel={(option) => `${option.name} with value ${option.value}`}
            style={{ width: 350 }}
            options={this.state.kudosTypesValues}
            onChange={this.onKudosTypeValueChange}
            renderInput={(params) => <TextField {...params} variant="outlined" />}
            renderOption={(option) => (
              <div>
                <h4>{option.name} with value {option.value}</h4>
              </div>
            )}
          />
        </div>
        <div className="form-group d-sm-flex justify-content-start align-items-center">
          <label className="no-padding col-4" htmlFor="reason">
            Please specify if needed, or leave your comments:
          </label>
          <textarea
            className="form-control"
            name="reason"
            value={this.state.reason}
            onChange={this.handleReasonChange}
            placeholder="Reason"
            id="reason"
            rows="2"
            style={{ resize: 'none' }}
          />
        </div>
        {userType === "1" && (
        <div className="d-flex justify-content-end" style={{ marginBottom: '20px' }}>
          <button variant="contained" className="btn btn-primary" onClick={this.handleOpenEditTypeModal}>
            Edit Types/Type Values
          </button>
        </div>
        )}
        <ShopSubmitBtn
          handleModalToggle={this.props.handleModalToggle}
          title="Submit"
          disabled={this.props.isPopupOpen}
          className={
            this.state.selectedEmployee &&
            this.state.reason &&
            this.state.selectedKudosType &&
            this.state.selectedKudosTypeValue
              ? `btn btn-primary`
              : `btn disabled`
          }
        />
        <CustomModal
          handleModalToggle={this.props.handleModalToggle}
          isModalOpen={this.props.isModalOpen}
          handleModalClose={this.props.handleModalClose}
          handleCancelAction={this.props.handleCancelAction}
          handleSubmitForm={this.handleRequestKudos}
          message="Are you sure you want to submit this request?"
        />

        {/* Edit Type Modal */}
        <EditTypeModal
          isOpen={this.state.isEditTypeModalOpen}
          typeBeingEdited={this.state.typeBeingEdited}
          valueBeingEdited={this.state.valueBeingEdited}
          editedTypeName={this.state.editedTypeName}
          editedValueName={this.state.editedValueName}
          editedValue={this.state.editedValue}
          editedIsAvailable={this.state.editedIsAvailable}
          handleEditTypeNameChange={this.handleEditTypeNameChange}
          handleEditValueNameChange={this.handleEditValueNameChange}
          handleEditValueChange={this.handleEditValueChange}
          handleEditIsAvailableChange={this.handleEditIsAvailableChange}
          handleSaveEditedType={this.handleSaveEditedType}
          handleSaveEditedValue={this.handleSaveEditedValue}
          handleCloseEditTypeModal={this.handleCloseEditTypeModal}
          handleBackFromEditTypeModal={this.handleBackFromEditTypeModal}
          handleOpenAddNewTypeModal={this.handleOpenAddNewTypeModal}
          kudosTypes={this.state.kudosTypes}
          editType={this.editType}
          handleDeleteType={this.handleDeleteType}
          toggleExpandType={this.toggleExpandType}
          expandedTypeId={this.state.expandedTypeId}
          handleOpenAddNewValueModal={this.handleOpenAddNewValueModal}
          kudosTypesValues={this.state.kudosTypesValues}
          editValueType={this.editValueType}
          handleDeleteValueType={this.handleDeleteValueType}
          userType={this.props.userType}
        />

        {/* Add New Type Modal */}
        <AddNewTypeModal
          isOpen={this.state.isAddNewTypeModalOpen}
          newTypeName={this.state.newTypeName}
          handleNewTypeNameChange={this.handleNewTypeNameChange}
          handleAddNewType={this.handleAddNewType}
          handleCloseAddNewTypeModal={this.handleCloseAddNewTypeModal}
          handleBackFromAddNewTypeModal={this.handleBackFromAddNewTypeModal}
        />

        {/* Add New Value Modal */}
        <AddNewValueModal
          isOpen={this.state.isAddNewValueModalOpen}
          selectedKudosType={this.state.selectedKudosType}
          handleCloseAddNewValueModal={this.handleCloseAddNewValueModal}
          setKudosTypesValues={(newValues) => this.setState({ kudosTypesValues: newValues })}
          handleNewValueNameChange={this.handleNewValueNameChange}
          handleNewValueChange={this.handleNewValueChange}
          handleAddNewValue = {this.handleAddNewValue}
        />
        <CustomModal
          handleModalClose={this.handleCloseConfirmationModal}
          handleCancelAction={this.handleCancelConfirmationAction}
          handleSubmitForm={this.handleConfirmAction}
          isModalOpen={isConfirmationModalOpen}
          message="Are you sure you want to perform this action?"
        />

        {/* Delete Value Confirmation Modal */}
        {process.env.REACT_APP_FEATURE_DELETE_TYPE_VALUES_AND_PRODUCTS === "true" && this.state.isDeleteValueModalOpen && (
          <DeleteConfirmationModal
            isOpen={this.state.isDeleteValueModalOpen}
            onClose={this.handleCloseDeleteValueModal}
            itemName={this.state.valueNameToDelete}
            hasLinkedRecords={this.state.deleteValuePreCheck?.hasLinkedRecords || false}
            transactionCount={this.state.deleteValuePreCheck?.transactionCount || 0}
            requestCount={this.state.deleteValuePreCheck?.requestCount || 0}
            onArchive={this.handleArchiveValue}
            onDelete={this.handlePermanentDeleteValue}
            isLoading={this.state.isDeleteLoading}
          />
        )}
      </>
    );
  }
}